import Text, { TEXT_VARIANT } from '@pixum/text';
import { type LinkNode, type InfoBannerNode } from 'data-layer';
import { CREATIVE_ID } from 'hooks';
import type { DeviceOrientedComponentProps } from '../../types';
import { Image, IMAGE_LOADING } from '../image';
import { RichTextContent } from '../richtText';
import { ButtonCollection } from '../buttonCollection';
import './styles.css';

export type InfoBannerProps = InfoBannerNode & DeviceOrientedComponentProps;

/**
 * info banner layout with an image on the left and text on the right on desktop
 * and on mobile the elements are below each other
 */
export function InfoBanner(props: InfoBannerProps) {
  const { title, text, image, device, links, hasLinks } = props;
  const infoText = text && <RichTextContent node={text} />;
  const infoImage = <Image device={device} image={image} loading={IMAGE_LOADING.LAZY} />;

  return (
    <div className="info-banner">
      <div className="info-banner__container" role="region" aria-label={title}>
        <div className="info-banner__image">{infoImage}</div>
        <div className="info-banner__text">
          {title && <Text variant={TEXT_VARIANT.TITLE_2}>{title}</Text>}
          <div>{infoText}</div>
        </div>
        {hasLinks && (
          <div className="info-banner__actions">
            <ButtonCollection buttons={links as LinkNode[]} device={device} creativeId={CREATIVE_ID.CONTENT} />
          </div>
        )}
      </div>
    </div>
  );
}
